import { gsap } from 'gsap';
import Headroom from 'headroom.js';
import { headerHeight } from '../helpers';

if (!window.dAgency) window.dAgency = {};

$(function () {
  const $siteHeader = $('.site-header');
  const $header = $siteHeader.find('.header__container');
  if ($siteHeader <= 0 || $header.length <= 0)
    return false;

  $('html').css('scroll-padding-top', headerHeight() + 'px');
  $('#PageContainer').css('min-height', 'calc(100vh - ' + headerHeight() + 'px)');
  $('#CartPopup').css('top', headerHeight() + 'px');

  $(window).on('resize', function () {
    $('html').css('scroll-padding-top', headerHeight() + 'px');
    $('#PageContainer').css('min-height', 'calc(100vh - ' + headerHeight() + 'px)');
    $('#CartPopup').css('top', headerHeight() + 'px');
  });

  /* ====================== HeadrooomJS ====================== */
  const header = document.querySelector('header.site-header');
  if (header) {
    const options = {
      tolerance: {
        up: 20,
        down: 20
      },
      onPin: function () {
        if (this.elem) {
          const $announcement = $(this.elem).find('#shopify-section-announcement-bar');
          if ($announcement.length > 0) {
            $announcement.slideDown(250);

            const $searchPopup = $header.find('.header__search-popup');
            if ($searchPopup.length > 0) {
              $deskSearchBar.css('top', headerHeight() + 'px');
              $searchPopup.css('top', headerHeight() + 'px');
            }
            $mobileMenu.css('top', headerHeight() + 'px');
            $mobileMenu.css('height', 'calc(100vh - ' + headerHeight() + 'px)');
            if ($desktopMenu.length > 0 && $desktopMenu.hasClass('header__desktop-menu--drawer')) {
              $desktopMenu.find('.header__desktop-menu--drawer__second-level').each(function () {
                $(this).css('height', 'calc(100vh - ' + headerHeight() + 'px)');
              });
            }
          }
        }
      },
      onUnpin: function () {
        if (this.elem) {
          const $announcement = $(this.elem).find('#shopify-section-announcement-bar');
          if ($announcement.length > 0) {
            $announcement.slideUp(250);

            const $searchPopup = $header.find('.header__search-popup');
            if ($searchPopup.length > 0) {
              $deskSearchBar.css('top', headerHeight() + 'px');
              $searchPopup.css('top', 'calc(' + headerHeight() + 'px - 34px)');
            }
            $mobileMenu.css('top', headerHeight() + 'px');
            $mobileMenu.css('height', 'calc(100vh - ' + headerHeight() + 'px)');
            if ($desktopMenu.length > 0 && $desktopMenu.hasClass('header__desktop-menu--drawer')) {
              $desktopMenu.find('.header__desktop-menu--drawer__second-level').each(function () {
                $(this).css('height', 'calc(100vh - ' + headerHeight() + 'px)');
              });
            }
          }
        }
      }
    };

    const headroom = new Headroom(header, options);
    headroom.init();
  }

  /* ======================== Header ======================== */
  if ($header.hasClass('header__transparent')) {
    if ($(window).scrollTop() === 0) {
      $header.addClass('apply-transparency');
    } else {
      $header.removeClass('apply-transparency');
    }

    $(window).on('scroll', function () {
      if (!$header.hasClass('force-opacity')) {
        if ($(window).scrollTop() === 0) {
          $header.addClass('apply-transparency');
        } else {
          $header.removeClass('apply-transparency');
        }
      }
    });
  }

  $header.on('mouseenter', function () {
    if ($(window).outerWidth() > 1024) {
      $header.removeClass('apply-transparency');
    }
  });
  $header.on('mouseleave', function () {
    if ($(window).scrollTop() === 0 && $(window).outerWidth() > 1024 && !$header.hasClass('force-opacity')) {
      $header.addClass('apply-transparency');
    }
  });

  $header.find('.header__left__newsletter-button').on('click', function () {
    if (typeof (window.dAgency.showNewsletterPopUp) === 'function') window.dAgency.showNewsletterPopUp();
  });

  /* ======================== Mobile Menu ======================== */
  const $mobileMenu = $header.find('.header__mobile-menu');
  if ($mobileMenu.length > 0) {
    $mobileMenu.css('top', headerHeight() + 'px');

    if (iOS()) {

      let bottomMenu = 0;
      if($('.header__container .header__mobile-menu--dropdown__footer').length > 0){
         bottomMenu = $('.header__container .header__mobile-menu--dropdown__footer').outerHeight() + headerHeight();
      }

      $mobileMenu.css({
         'padding-bottom': bottomMenu,
         'min-height' : '-webkit-fill-available'
      });
    } else {
      $mobileMenu.css('height', 'calc(100vh - ' + headerHeight() + 'px)');
    }

    $mobileMenu.find('[data-link-opener]').on('click', function (e) {
      if (e.target.getAttribute('href')) return;

      const drawerAttribute = $(this).data('link-opener');
      const $drawer = $(this).parent().find('[data-level="' + drawerAttribute + '"]');
      if ($drawer.length > 0) {
        $drawer.addClass('open');
      }
    });

    $mobileMenu.find('[data-close-level]').on('click', function () {
      $(this).parent().removeClass('open');
    });

    $mobileMenu.find('.header__mobile-menu--dropdown__tabs__title').on('click', function () {
      $(this).siblings().removeClass('active');
      $(this).addClass('active');
    });

    const burgerTop = document.getElementById('burger-bar-top');
    const burgerMiddle = document.getElementById('burger-bar-middle');
    const burgerBottom = document.getElementById('burger-bar-bottom');
    var tl = gsap.timeline();

    var isMenuOpen = false;
    $header.find('.header__burger-icon').on('click', function () {
      isMenuOpen = !isMenuOpen;
      $mobileMenu.toggleClass('open');
      if (isMenuOpen) {
        $('html').css('overflow-y', 'hidden');
        $header.removeClass('apply-transparency');
        $header.addClass('force-opacity');
        $header.find('.header__search-popup.open').removeClass('open');

        tl = gsap.timeline();
        tl.to(burgerTop, { rotate: 45, duration: 1, y: 7, transformOrigin: 'center', ease: 'elastic.out(1, 0.4)' }, 0);
        tl.to(burgerMiddle, { scaleX: 0, duration: 1, opacity: 0, transformOrigin: 'center', ease: 'elastic.out(1, 0.4)' }, 0);
        tl.to(burgerBottom, { rotate: -45, duration: 1, y: -7, transformOrigin: 'center', ease: 'elastic.out(1, 0.4)' }, 0);
      } else {
        $('html').css('overflow-y', '');
        $header.removeClass('force-opacity');
        if ($(window).scrollTop() === 0) {
          $header.addClass('apply-transparency');
        }

        tl = gsap.timeline();
        tl.to(burgerTop, { rotate: 0, duration: 1, y: 0, transformOrigin: 'center', ease: 'elastic.out(1, 0.4)' }, 0);
        tl.to(burgerMiddle, { scaleX: 1, duration: 1, opacity: 1, transformOrigin: 'center', ease: 'elastic.out(1, 0.4)' }, 0);
        tl.to(burgerBottom, { rotate: 0, duration: 1, y: 0, transformOrigin: 'center', ease: 'elastic.out(1, 0.4)' }, 0);
      }
    });

    const $mobileMenuImages = $('.header__mobile-menu__level__image');
    if ($mobileMenuImages.length > 0) {
      $mobileMenuImages.each(function () {
        const $links = $(this).prev();
        $links.css('height', 'calc(100% - ' + $(this).innerHeight() + 'px - 1rem)');
      });
    }

    $('[data-mobile-menu-opener]').on('click', function (e) {
      if (!e.target.getAttribute('href')) {
        const menuName = $(this).data('mobile-menu-opener');
        $('[data-mobile-menu="' + menuName + '"]').css('transform', 'translate3d(0, 0, 0)');
      }
    });

    $('[data-mobile-menu] .header__mobile-menu__level__title').on('click', function () {
      const $menu = $(this).closest('.header__mobile-menu__level');
      $menu.css('transform', '');
    });
  }

  /* ======================== Desktop Menu ======================== */
  const $desktopMenu = $header.find('.header__desktop-menu');
  const $leftMenu = $header.find('.header__left__menu');
  const $backdropMenu = $header.find('.header__desktop-menu--drawer__backdrop');

  if ($desktopMenu.length > 0) {

    // Manage "level 0"

    const $initialLevelLinks = $leftMenu.find('.header__desktop-menu--drawer__inline-elements__link.level-0 > span')
    $initialLevelLinks.each(function () {

      $(this).on('click', function () {
        if ($(window).outerWidth() <= 1024) return;

        $(this).parent().toggleClass('open');
        $(this).parent().siblings().removeClass('open');
        $desktopMenu.find('.hoverable.active').removeClass('active');
        $header.find('.header__search-popup.open').removeClass('open');

        if ($(this).parent().hasClass('open')) {
          $('html').css('overflow-y', 'hidden');
          $header.addClass('force-opacity');
        } else {
          $('html').css('overflow-y', '');
          $header.removeClass('force-opacity');
        }
      });
    });

    // Manage "level 1"

    const $firstLevelLinks = $desktopMenu.find('.header__desktop-menu--drawer__inline-elements__link')
    $firstLevelLinks.each(function () {

      $(this).on('click', function () {
        if ($(window).outerWidth() <= 1024) return;

        $(this).addClass('open');
        $(this).siblings().removeClass('open');
      });
    });

    $desktopMenu.find('.header__desktop-menu--drawer__second-level').each(function () {
      $(this).css('height', 'calc(100vh - ' + headerHeight() + 'px)');

      const $level = $(this);
      $(this).find('.header__desktop-menu--drawer__second-level__title.clickable').on('click', function (e) {
        if (e.target.getAttribute('href')) return;

        const levelIndex = $(this).data('submenu');
        $level.find('.header__desktop-menu--drawer__third-level[data-submenu="' + levelIndex + '"]').addClass('open');
      });
    });

    $(this).find('.header__desktop-menu--drawer__third-level').each(function () {
      const $thirdLevel = $(this);
      const $overflowContainer = $(this).find('.header__desktop-menu--drawer__third-level__overflow-container');
      const $goBack = $(this).find('.header__desktop-menu--drawer__third-level__go-back');

      $overflowContainer.css('height', 'calc(100% - ' + $goBack.outerHeight() + 'px)');
      $goBack.on('click', function () {
        $thirdLevel.removeClass('open');
      });
    });

    $desktopMenu.find('.header__desktop-menu--drawer__second-level__title.hoverable').each(function () {

      const $level = $(this);
      $(this).on('click', function (e) {
        if (e.target.getAttribute('href')) return;

        $(this).siblings().removeClass('active');
        $(this).toggleClass('active');
      });
    });

    // Manage click on backdrop

    $backdropMenu.on('click', function () {
      if ($(window).outerWidth() <= 1024) return;

      $leftMenu.find('.header__desktop-menu--drawer__inline-elements__link.level-0.open').removeClass('open');
      $desktopMenu.find('.hoverable.active').removeClass('active');
      $('html').css('overflow-y', '');
      $header.removeClass('force-opacity');
    });
  }

  /* ==================== Desktop Search PopUp ==================== */
  const $deskSearchBar = $header.find('.header__search-popup');
  if ($deskSearchBar.length > 0) {
    $deskSearchBar.css('top', headerHeight() + 'px');

    const $iconSearch = $header.find('.header__right__element.search');
    if ($iconSearch.length > 0) {
      $iconSearch.on('click', function (e) {
        e.preventDefault();
        $deskSearchBar.toggleClass('open');

        if ($deskSearchBar.hasClass('open')) {
          $leftMenu.find('.header__desktop-menu--drawer__inline-elements__link.level-0.open').removeClass('open');
          $desktopMenu.find('.hoverable.active').removeClass('active');
          $header.removeClass('apply-transparency');
          $header.addClass('force-opacity');
          $deskSearchBar.find('form input[type="text"]').trigger('focus');

        } else {
          $header.removeClass('force-opacity');
          if ($(window).scrollTop() === 0) {
            $header.addClass('apply-transparency');
          }
        }
      });
    }

    $(window).on('resize', function () {
      if ($(window).outerWidth() <= 1024) {
        $header.removeClass('force-opacity');

        if ($(window).scrollTop() === 0) {
          $header.addClass('apply-transparency');
        } else {
          $header.removeClass('apply-transparency');
        }
      } else {
        $deskSearchBar.css('top', headerHeight() + 'px');
      }
    });

    const $closeIcon = $deskSearchBar.find('.header__search-popup__close-icon');
    if ($closeIcon.length > 0) {
      $closeIcon.on('click', function () {
        $deskSearchBar.removeClass('open');
        $header.removeClass('force-opacity');
        if ($(window).scrollTop() === 0) {
          $header.addClass('apply-transparency');
        }
      });
    }
  }
});



function iOS() {
  return [
      'iPad Simulator',
      'iPhone Simulator',
      'iPod Simulator',
      'iPad',
      'iPhone',
      'iPod'
    ].includes(navigator.platform) ||
    (navigator.userAgent.includes("Mac") && "ontouchend" in document)
}
